// extracted by mini-css-extract-plugin
export default {"body":"MobileTooltip_body","contentBlock":"MobileTooltip_contentBlock","footer":"MobileTooltip_footer","buttonClose":"MobileTooltip_buttonClose"};